import React from 'react'
import { DragDropContext } from 'react-beautiful-dnd'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import ListGroupUI from './ListGroupUI'
import ActionRightUI from './ActionRightUI'
import ProjectAvatarListUI from './ProjectAvatarListUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import './TaskList.css'

const TaskListUI = ({context, messageList, project, taskList, currentTask, onSetEditMode,
    projectUserList, projectUserMap,
    // filters
    statusFilter, statusList, onStatusFilterChange,
    priorityFilter, priorityList, onPriorityFilterChange,
    dueDateDaysFilter, onDueDateDaysFilterChange,
    searchFilter, onSearchFilterChange,
    assigneeFilter, onAssigneeFilterClick,
    unfoldedTaskIdSet,
    // top action clicks
    onRefreshClick, onUnfoldAllClick, onFoldAllClick, onCreateClick,
    onDeleteClick, onIndentClick, onOutdentClick, onMoveClick, moveMode,
    // row level clicks
    onUnfoldClick, onFoldClick, onTaskClick,
    onTaskNameCreateOrUpdate,
    // dnd
    onBeforeCapture, onDragEnd
  }) =>
  <div className='tsk_list g_h_100'>
    <ProjectAvatarListUI
      context={context}
      messageList={messageList}
      project={project}
      assigneeFilter={assigneeFilter}
      projectUserList={projectUserList}
      onAssigneeFilterClick={onAssigneeFilterClick}
    />
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          project={project}
          taskList={taskList}
          currentTask={currentTask}
          onRefreshClick={onRefreshClick}
          onUnfoldAllClick={onUnfoldAllClick}
          onFoldAllClick={onFoldAllClick}
          onCreateClick={onCreateClick}
          onDeleteClick={onDeleteClick}
          onIndentClick={onIndentClick}
          onOutdentClick={onOutdentClick}
          onMoveClick={onMoveClick}
          moveMode={moveMode}
        />
      }
      right={
        <ActionRightUI
          context={context}
          messageList={messageList}
          statusList={statusList}
          priorityList={priorityList}
          statusFilter={statusFilter}
          searchFilter={searchFilter}
          priorityFilter={priorityFilter}
          dueDateDaysFilter={dueDateDaysFilter}
          onStatusFilterChange={onStatusFilterChange}
          onSearchFilterChange={onSearchFilterChange}
          onPriorityFilterChange={onPriorityFilterChange}
          onDueDateDaysFilterChange={onDueDateDaysFilterChange}
        />
      }
    />

    <LRTableBodyUI className={`no_scroll ${!taskList ? 'g_flex_v' : ''}`}>
      {
        !taskList &&
        <SpinnerComponentUI />
      }

      { /* to understand tree generation, check the rendered HTML */
        taskList &&
        <DragDropContext onBeforeCapture={onBeforeCapture} onDragEnd={onDragEnd}>
          <ListGroupUI
            context={context}
            messageList={messageList}
            project={project}
            taskList={taskList}
            groupTaskId='root'
            currentTask={currentTask}
            projectUserMap={projectUserMap}
            onSetEditMode={onSetEditMode}
            onTaskClick={onTaskClick}
            onUnfoldClick={onUnfoldClick}
            onFoldClick={onFoldClick}
            unfoldedTaskIdSet={unfoldedTaskIdSet}
            onTaskNameCreateOrUpdate={onTaskNameCreateOrUpdate}
            moveMode={moveMode}
          />
        </DragDropContext>
     }
    </LRTableBodyUI>
  </div>

const ActionLeftUI = ({context, messageList, project, taskList, currentTask,
    onRefreshClick, onUnfoldAllClick, onFoldAllClick, onCreateClick,
    onDeleteClick, onIndentClick, onOutdentClick, onMoveClick, moveMode
  }) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' shortCutKey='' />
    <IconButtonUI messageList={messageList} icon='icon-folder-open-o' onClick={onUnfoldAllClick} labelKey='c_unfold_tasks' shortCutKey='' />
    <IconButtonUI messageList={messageList} icon='icon-folder-o' onClick={onFoldAllClick} labelKey='c_fold_tasks' shortCutKey='' />
    {
      project.permissionList.includes('prj_participate') &&
      <React.Fragment>
        <IconButtonUI messageList={messageList} icon='icon-plus' onClick={onCreateClick} labelKey='c_add_task' shortCutKey='c_kb_shortcut_create' />
        {
          currentTask &&
          <React.Fragment>
            <IconButtonUI messageList={messageList} icon='icon-trash-o' onClick={onDeleteClick} labelKey='c_delete_task' shortCutKey='c_kb_shortcut_delete' />
            {
              currentTask.precedingTaskId &&
              <IconButtonUI messageList={messageList} icon='icon-indent' onClick={onIndentClick} labelKey='c_make_subtask' shortCutKey='c_kb_shortcut_indent' />
            }
            {
              currentTask.parentTaskId &&
              <IconButtonUI messageList={messageList} icon='icon-outdent' onClick={onOutdentClick} labelKey='c_make_parent_task' shortCutKey='c_kb_shortcut_outdent' />
            }
          </React.Fragment>
        }
        {/*
          <IconButtonUI messageList={messageList} icon='icon-arrows' selected={moveMode} onClick={onMoveClick} labelKey='c_move_tasks' shortCutKey='' />
        */}
      </React.Fragment>
    }
  </div>

export default TaskListUI
